import _ from 'lodash'

import { TableColumn } from 'components/Table/Table'

import i18n from 'translations'

export const TABLE_COLUMNS: TableColumn[] = [
  {
    align: 'left',
    alignTh: 'left',
    field: 'child',
    title: _.upperFirst(i18n.t('global:child')),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'medication',
    title: i18n.t('module:Safeguarding:MedicationForm:List:Table:medication'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'startEndDate',
    title: i18n.t('module:Safeguarding:MedicationForm:List:Table:startEndDate'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'frequency',
    title: i18n.t('module:Safeguarding:MedicationForm:List:Table:frequency'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'reviewDate',
    title: i18n.t('module:Safeguarding:MedicationForm:List:Table:reviewDate'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'expiryDate',
    title: i18n.t('module:Safeguarding:MedicationForm:List:Table:expiryDate'),
    width: '120px',
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'status',
    title: _.upperFirst(i18n.t('global:status')),
  },
  {
    field: 'actions',
  },
]
